/*<==================== STEP 1 ====================*/
var elemToObserveStep1 = document.querySelector('.measures-instructions-modal');
var elemToAddClass = document.querySelector('body');
var prevClassState = elemToObserveStep1.classList.contains('hidden');

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
    if (mutation.attributeName == "class") {
        var currentClassState = mutation.target.classList.contains('hidden');
        if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (currentClassState) { //console.log('AddBLOCK');
            elemToAddClass.classList.remove('blockBackground');
        } else { // console.log('RemoveBLOCK');
            elemToAddClass.classList.add('blockBackground');
        }



        }
    }
    });
});

observer.observe(elemToObserveStep1, {attributes: true});

/*<==================== STEP 2 ====================*/
var elemToObserveStep2 = document.querySelector('.fall-modal');
var elemToAddClass = document.querySelector('body');
var prevClassState = elemToObserveStep2.classList.contains('hidden');

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
    if (mutation.attributeName == "class") {
        var currentClassState = mutation.target.classList.contains('hidden');
        if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (currentClassState) { //console.log('AddBLOCK');
            elemToAddClass.classList.remove('blockBackground');
        } else { // console.log('RemoveBLOCK');
            elemToAddClass.classList.add('blockBackground');
        }



        }
    }
    });
});

observer.observe(elemToObserveStep2, {attributes: true});

/*<==================== STEP 3 ====================*/
var elemToObserveStep3 = document.querySelector('.chain-modal');
var elemToAddClass = document.querySelector('body');
var prevClassState = elemToObserveStep3.classList.contains('hidden');

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
    if (mutation.attributeName == "class") {
        var currentClassState = mutation.target.classList.contains('hidden');
        if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (currentClassState) { //console.log('AddBLOCK');
            elemToAddClass.classList.remove('blockBackground');
        } else { // console.log('RemoveBLOCK');
            elemToAddClass.classList.add('blockBackground');
        }



        }
    }
    });
});

observer.observe(elemToObserveStep3, {attributes: true});


/*<==================== STEP 4 ====================*/
var elemToObserveStep4 = document.querySelector('.installation-modal');
var elemToAddClass = document.querySelector('body');
var prevClassState = elemToObserveStep4.classList.contains('hidden');

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
    if (mutation.attributeName == "class") {
        var currentClassState = mutation.target.classList.contains('hidden');
        if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (currentClassState) { //console.log('AddBLOCK');
            elemToAddClass.classList.remove('blockBackground');
        } else { // console.log('RemoveBLOCK');
            elemToAddClass.classList.add('blockBackground');
        }



        }
    }
    });
});

observer.observe(elemToObserveStep4, {attributes: true});


/*<==================== Click outside box ====================*/
window.addEventListener('click', function(e) {

    if (document.querySelector('.modal').contains(e.target)) {

    } else {
        var modalClose = document.querySelectorAll('.modal');

        for (i = 0; i < modalClose.length; ++i) {
            modalClose[i].classList.add('hidden');
        }
    }
})